import React from 'react';
import translations from 'services/translations/translations';
import { useTranslation } from 'react-i18next';
import 'style/layout/navbar/InfoBar.css';
import TextInputField from 'components/layout/forms/TextInputField';

const InfoBar = ({
  infoData,
  setInfoBarOpen,
}: {
  infoData: any;
  setInfoBarOpen: (status: boolean) => void;
}): JSX.Element => {
  const { t } = useTranslation([translations.common]);

  const capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const closeInfoBar = () => {
    setInfoBarOpen(false);
  };

  const getPropertiesToDisplay = () => {
    if (!(infoData && infoData.exportParameters)) {
      return null;
    }

    return Object.keys(infoData.exportParameters).map((key) => {
      if (String(infoData.exportParameters[key]) === '') {
        return null;
      }

      return (
        <TextInputField
          id={key}
          key={key}
          label={capitalizeFirstLetter(key)}
          name={key}
          value={infoData.exportParameters[key]}
        />
      );
    });
  };

  return (
    <div className="info-bar-content">
      <div>
        <h2 id="close-actions" onClick={closeInfoBar}>
          ×
        </h2>
        <h3>
          {t(
            `${translations.common}:Information Properties.Information`
          ).toLocaleUpperCase()}
        </h3>
      </div>
      {/* eslint-disable-next-line no-nested-ternary */}
      {infoData != null ? (
        'factoryFileName' in infoData ? (
          <TextInputField
            id="name"
            label={t(`${translations.common}:Information Properties.Name`)}
            name="name"
            value={infoData.factoryFileName}
          />
        ) : (
          <TextInputField
            id="name"
            label={t(`${translations.common}:Information Properties.Name`)}
            name="name"
            value={infoData.name}
          />
        )
      ) : (
        ''
      )}
      {getPropertiesToDisplay()}
    </div>
  );
};

export default InfoBar;
